/**
 *  From https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
export const hash = (string: string) => {
  let hash = 0
  if (string.length === 0) return hash
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }
  return hash
}

const FNV_OFFSET_BASIS = 2166136261
const FNV_PRIME = 16777619

function fnv1a(str: string): number {
  let hash = FNV_OFFSET_BASIS
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i)
    hash = (hash * FNV_PRIME) >>> 0
  }
  return hash
}

export function fnv1aHex(string: string): string {
  const h = fnv1a(string)
  return h.toString(16).padStart(8, '0')
}
